export const GenCodes = [
  'JR',
  'JR.',
  'SR',
  'SR.',
  'Jr',
  'Jr.',
  'Sr',
  'Sr.',
  'jr',
  'jr.',
  'sr',
  'sr.',
  'Junior',
  'JUNIOR',
  'junior',
  'Senior',
  'SENIOR',
  'senior',
  '2',
  '02',
  ' 2',
  '2 ',
  'II',
  'ii',
  '3',
  '03',
  ' 3',
  '3 ',
  'III',
  'iii',
  '4',
  '04',
  ' 4',
  '4 ',
  'IV',
  'iv',
  '5',
  '05',
  ' 5',
  '5 ',
  'V',
  'v',
  '6',
  '06',
  ' 6',
  '6 ',
  'VI',
  'vi',
  '7',
  '07',
  ' 7',
  '7 ',
  'VII',
  'vii',
  '8',
  '08',
  ' 8',
  '8 ',
  'VIII',
  'viii',
  '9',
  '09',
  ' 9',
  '9 ',
  'IX',
  'ix',
  '',
];
